import React from 'react';
import { connect } from 'dva';
import MeetingList from '../components/meetingList/MeetingList';
import { injectIntl } from 'react-intl';

export default connect(state => {
  return {
    ...state,
    loading: state.loading.global
  };
})(
  injectIntl(({ meeting, meetingList, loading, intl, dispatch, login, account, i18n }) => {
    return (
      <MeetingList
        meetingTreeData={meeting.meetingTreeData}
        meetingPolicy={account.meetingPolicy}
        intl={intl}
        dispatch={dispatch}
        meetingList={meetingList}
        loading={loading}
        userByDept={meeting.userByDept}
        userInfo={login.userInfo}
        maxDelayTime={account.meetingPolicy.maxDelayTime}
        locale={i18n.locale}
      />
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/MeetingList.js